/**
 * The optics engine — docs/FeatureDesigns/optics/optics-engine-target.md.
 *
 * A separate engine from the mechanics one, sharing no code with it. The
 * surface that uses it is Backend/shared-ui/optics-bench.
 */
import { registerBuiltInKinds } from './kinds';

registerBuiltInKinds();

export * from './types';
export * from './vec';
export * from './registry';
export * from './trace';
export * from './construction';
export * from './convention';
export * from './image';
export * from './analyse';
export * from './diagnose';
export * from './edit';
export * from './presets';
export * from './kinds';
export * from './working';
export { sag } from './shapes';
